import styled      from "styled-components";
import imagemFundo from "../assets/fundo-sistema.jpg";
import {Card}      from "primereact/card";

export const FundoSistema = styled.div`
  background-image: url(${imagemFundo});
  background-repeat: no-repeat;
  background-size: cover;
  width: 95vw;
  min-height: 90vh;
  margin: auto;
  margin-top: 5vh;
  padding:1vh;
`;

export const TelaSistema= styled(Card)`
  margin-top: 10px;
`;

export const CabecalhoTabela = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Obrigatorio = styled.span`
	color: #ff0000;
	padding-left: 5px;
`;